<template>
  <div class="preferential">
    <div class="preferential-header">
      <div class="preferential-header-bg">
        <img src="../assets/images/preferential-bg.png" alt="">
      </div>
      <h1  v-if="couponInfo.totalValue">
        你共有<span>{{couponInfo.totalValue}}元代金券</span>未使用
      </h1>
    </div>
    <div class="preferential-coupon" v-if="couponInfo.value">
      <div class="preferential-coupon-bg">
        <img src="../assets/images/preferential-coupon.png" alt="">
      </div>
      <div class="preferential-coupon-ctx">
        <div class="preferential-coupon-ctx-l">
          <p>{{couponInfo.value}}<i>元</i></p>
        </div>
        <div class="preferential-coupon-ctx-r">
          <p>{{couponInfo.applyCourse}}{{couponInfo.value}}元代金券</p>
          <p>有效期至:{{endTime}}</p>
        </div>
      </div>
    </div>
    <div class="preferential-courses">
        <preferential-block v-for="(item, index) in couponCourses" :courseInfo="item" :key="index" @buy="buy"></preferential-block>
    </div>
    <p class="preferential-bottom">
      本活动页优惠专栏不定期更新，看上了请及时购买哟
    </p>
    <PreferentialBubble
      :couponPopList="couponPopList"
      v-if="couponPopList.length"/>
    <div class="preferential-toast" v-if="isToastShow" @click="closeToast">
      <div class="preferential-toast-main">
        <div class="preferential-toast-bg">
          <img src="../assets/images/coupon-bubble.png" alt="">
        </div>
        <div class="preferential-toast-price">{{couponPrice}}</div>
        <div class="preferential-toast-desc" v-if="threshold">
          满{{threshold}}可用 <template v-if="couponTime">,有效期{{couponTime}}天</template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import keys from 'lodash.keys'
import module from '../modules/preferential'
import Pay from '@edu-fe/pay'
import assign from 'lodash.assign'
import api from '@edu-fe/api'
import os from '@edu-fe/os'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import PreferentialBlock from '../components/Preferential/PreferentialBlock'
import PreferentialBubble from '../components/Preferential/PreferentialBubble'
export default {
  data () {
    return {
      paying: false,
      isToastShow: false,
    }
  },
  computed: {
    ...mapState(['launchOptions', 'userInfo']),
    ...mapState(module.name, keys(module.state)),
    ...mapGetters(module.name, keys(module.getters)),
    endTime () {
      let endTime = ''
      if (this.couponInfo.useEnd) {
        endTime = this.couponInfo.useEnd.replace(/-/g,'.')
        endTime = endTime.substr(0, endTime.length-3)
      }
      return endTime
    },
    couponPrice () {
      return this.$route.query.couponPrice
    },
    couponTime () {
      return this.$route.query.couponTime
    },
    threshold () {
      return this.$route.query.threshold
    }
  },
  watch: {
    couponPrice: {
      handler (val) {
        if (val) {
          this.isToastShow = true
        }
      },
      immediate: true
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name) {
      return next(vm => {
        vm.isToastShow = false
      })
    }
    next()
  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),

    closeToast () {
      this.isToastShow = !this.isToastShow
    },
    buy (courseInfo) {
      if (os.type === 'app') {
        if (os.name === 'android' || os.name === 'ios') {
          return os.sdk.pay.call({
            goodId: courseInfo.id,
            goodType: 1
          })
        }
      }
      this.paying = true
      const params = assign({}, this.buyInfo(courseInfo))
      //  if(!courseInfo.price) {
      //   params.free = true
      // }
      new Pay(params)
    },
    buyInfo (courseInfo) {
      return {
        courseId: courseInfo.id,
        type: 1,
        from: this.launchOptions.from,
        token: this.$route.query.token,
        gotoResult: orderId => {
          // 因 successCallback 废弃，因此在几种回调中处理支付状态
          this.paying = false
          const page = location.protocol + '//' + location.host + '/sign-up-result-ok2?orderId=' + orderId + '&courseId=' + courseInfo.id
          if (os.name === 'loan') {
            window.jsBridge && jsBridge.goToEduSuccess(JSON.stringify({
              page: 'KSWPSPageController',
              animated: false,
              urlString: page
            }))
          } else {
            location.href = page
          }
        },
        gotoPayment: () => {
          // 同 line 215
          this.paying = false

          this.$router.push({
            name: 'pay',
            query: {
              courseId: courseInfo.id,
              token: this.$route.query.token
            }
          })
        },
        hasBuyCallback: () => {
          this.paying = false
          this.$toast.show({
            message: '已购买'
          })
        },
        loginCallback: wpsSid => {
          this.paying = false
          this.init()
        },
        failCallback: () => {
          this.paying = false
        },
        cancelCallback: () => {
          this.paying = false
        }
      }
    },
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  created () {
    console.log(1111111)
    this.init()
  },
  beforeDestroy () {
    this.$store.unregisterModule(module.name)
  },
  components: {
    PreferentialBlock,
    PreferentialBubble
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.preferential {
  &-toast {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(#000, .4);
    &-main {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &-bg {
      width: rem(630);
      > img {
        width: 100%;
      }
    }
    &-desc {
      width: 100%;
      text-align: center;
      font-size: rem(32);
      color: #977E5A;
      position: absolute;
      top: rem(430);
    }
    &-price {
      &:after {
        content: '元';
        font-size: rem(88);
        /*background: linear-gradient(to bottom, #FF4A94, #FF4421);*/
        /*-webkit-background-clip: text;*/
        color: #A87E56;
      }
      width: 100%;
      text-align: center;
      font-size: rem(156);
      /*background: linear-gradient(to bottom, #FF4A94, #FF4421);*/
      /*-webkit-background-clip: text;*/
      color: #A87E56;
      font-weight: bold;
      position: absolute;
      top: rem(98);
    }
  }
  &-header {
    position: relative;
    color: #fff;
    text-align: center;
    padding-top: rem(69);
    line-height: 1.5;
    margin-bottom: rem(42);
    img{
      width: 100%;
    }
    h1 {
      font-size: rem(48);
      > span {
        color: #FFECB2;
      }
    }
    p {
      font-size: rem(24);
    }
    &-bg {
      position: absolute;
      top:0;
      left: 0;
      z-index: -1;
    }
  }
  &-bottom {
    font-size: rem(24);
    background: url('../assets/images/preferential-bg2.png');
    color: #FF9A94;
    text-align: center;
    font-weight: 500;
    padding-top: rem(15);
    padding-bottom: rem(63);
  }
  &-courses {
    padding: 0 rem(35);
    min-height: 85vh;
    background: url('../assets/images/preferential-bg2.png');
    margin: auto;
    font-size: 0;
    > div {
      &:nth-child(2n) {
        margin-right: 0;
      }
    }
    &::after{
      content: '';
      display: block;
      clear: both;
    }
  }
  &-coupon {
    width: rem(669);
    height: rem(286);
    margin: auto;
    position: relative;
    padding-top: rem(40);

    img{
      width: 100%;
    }
    &-bg {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }
    &-ctx {
      display: flex;
      justify-content: center;
      align-items: center;
      &-l {
        font-size: rem(90);
        color: #F48F00;
        font-weight: 500;
        margin-right: rem(43);
        i {
          font-size: rem(40);
        }
      }
      &-r{
        font-size: rem(26);
        line-height: 1.5;
        > p {
          &:first-child{
            color: #F48F00;
            margin-bottom: rem(10);
          }
        }
      }
    }
  }
}
</style>
